import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {AnonymousButtonsContainerDefaultBox} from "./anonymous-buttons-container.default.box";
import {AnonymousButtonsContainerHarrahsBox} from "./anonymous-buttons-container.harrahs.box";

export const AnonymousButtonsContainerBox = styledByTheme(AnonymousButtonsContainerDefaultBox)
    .forHarrahs(AnonymousButtonsContainerHarrahsBox)
    .apply();
